import { Howl } from 'howler'

const sound = new Howl({
  src: ['https://dfmujphw37ad8.cloudfront.net/sprite2.mp3'],
  preload: true,
  sprite: {
    'c': [0, 2000],
    'd': [2000, 2000],
    'e': [4000, 2000],
    'f': [6000, 2000],
    'g': [8000, 2000],
    'a': [10000, 2000],
    'b': [12000, 2000],
    'c2': [14000, 2000],
    'riff1': [16000, 9000],
    'riff2': [26000, 4000],
    'riff3': [31000, 8000],
    'riff4': [40000, 9500],
    'riff5': [52000, 7500],
    'riff6': [60000, 8500],
    'riff7': [69000, 10000],
  }
})


const NOTES = ['c', 'd', 'e', 'f', 'g', 'a', 'b', 'c2']
const RIFFS = ['riff3', 'riff1', 'riff2', 'riff4', 'riff5', 'riff6', 'riff7']


export function play(id: string) {
  sound.play(id)
}


export function playNote(index: number) {
  const id = NOTES[index % NOTES.length]
  play(id)
}


export function playRiff(index: number) {
  const id = RIFFS[index % RIFFS.length]
  play(id)
}


export default sound


// WEBPACK FOOTER //
// ./src/service/sound.ts